import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight'
import { ShowMore } from 'pages/Home/components/ShowMore'
import { CategoryTitle, CategorySubtitle } from '../'

import styles from './CategoryHeader.module.scss'

interface Props {
  title: string
  count: number
  showMoreText: string
  showMoreLink: string
  subtitle?: string
}

export const CategoryHeader: React.FC<Props> = ({
  title,
  count,
  showMoreText,
  showMoreLink,
  subtitle,
}) => {
  return (
    <div className={styles.container}>
      <CategoryTitle title={title} count={count} />
      <div className={styles.subtitleContainer}>
        {subtitle && <CategorySubtitle subtitle={subtitle} />}
        <ShowMore to={showMoreLink}>
          {showMoreText}
          <FontAwesomeIcon icon={faArrowRight} className={styles.arrow} />
        </ShowMore>
      </div>
    </div>
  )
}
